import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "withdraw-list"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "线上支付账款自动分账至销售团队主体至此模块进行金额提现", -1);

const _hoisted_3 = {
  class: "flex-center"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "待入账金额", -1);

const _hoisted_5 = {
  class: "flex-center"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "冻结金额", -1);

const _hoisted_7 = /*#__PURE__*/_createTextVNode("提现");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("提现记录");

const _hoisted_9 = {
  style: {
    "margin-bottom": "10px"
  }
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定");

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'supplier-withdraw',
  props: {
    supplierId: [Number, String]
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const router = useRouter();
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '提现角色',
        field: 'participateRoleName'
      }, {
        title: '团队',
        field: 'supplierName'
      }, {
        title: '可提现金额',
        field: 'unWithdrawAmount'
      }, {
        title: '已入账金额',
        field: 'waitWithdrawAmount'
      }, {
        title: '冻结金额',
        field: 'freezeAmont',
        slots: {
          header: 'freezeAmontHeader'
        }
      }, {
        title: '提现笔数',
        field: 'withdrawNum'
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            return new Promise(resolve => {
              let params = {
                page: page.currentPage,
                pageSize: page.pageSize,
                supplierId: props.supplierId,
                isOnlineCreditPay: 0
              };
              Axios.get('/admin/split/withdraw/supplierList.json', {
                params
              }).then(res => {
                if (!res.data.success) return;
                resolve({
                  total: res.data.data.total,
                  result: res.data.data.list
                });
              });
            });
          }
        }
      }
    });
    const withdrawModal = ref({
      show: false,
      data: {}
    });

    function withdrawHandle(row) {
      if (parseFloat(row.unWithdrawAmount) === 0) {
        ElMessage.error('无可提现金额');
        return;
      }

      withdrawModal.value = {
        show: true,
        data: row
      };
    }

    function withdrawConfirm() {
      let {
        participateId,
        participateRole,
        unWithdrawAmount
      } = withdrawModal.value.data;
      let url = `/admin/split/withdraw/supplierWithdraw.json?participateId=${participateId}&participateRole=${participateRole}&unWithdrawAmount=${unWithdrawAmount}&isOnlineCreditPay=0`;
      Axios.post(url).then(res => {
        let {
          success,
          msg
        } = res.data;

        if (success) {
          ElMessage.success('操作成功');
          table.value.commitProxy('reload');
          withdrawModal.value.show = false;
        } else {
          ElMessage.error(msg);
        }
      });
    }

    function initTable() {
      table.value.commitProxy('reload');
    }

    function toWithdraw(row) {
      let query = {
        participateId: row.participateId,
        participateRole: row.participateRole,
        isOnlineCreditPay: 0
      };
      router.push({
        name: 'sepaccountWithdrawHistory',
        query
      });
    }

    expose({
      initTable
    });
    return (_ctx, _cache) => {
      const _component_QuestionFilled = _resolveComponent("QuestionFilled");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        unEntryAmontHeader: _withCtx(() => [_createVNode(_component_el_tooltip, {
          content: "订单未完成"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_QuestionFilled)]),
            _: 1
          })])]),
          _: 1
        })]),
        freezeAmontHeader: _withCtx(() => [_createVNode(_component_el_tooltip, {
          content: "订单正在退款中金额将会冻结"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_QuestionFilled)]),
            _: 1
          })])]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [row.showWithdraw == 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          size: "small",
          onClick: $event => withdrawHandle(row)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $event => toWithdraw(row)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        modelValue: withdrawModal.value.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => withdrawModal.value.show = $event),
        title: "提现确认",
        width: "400px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => withdrawModal.value.show = false)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: withdrawConfirm
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", _hoisted_9, "提现方：" + _toDisplayString(withdrawModal.value.data.supplierName), 1), _createElementVNode("p", null, "提现金额：￥" + _toDisplayString(withdrawModal.value.data.unWithdrawAmount), 1)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};